import { Asterisk } from "lucide-react";
import { MARQUEE_ITEMS } from "../data/content";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="bg-navy text-white overflow-hidden py-5 relative"
      aria-hidden="true"
    >
      <div className="marquee-track flex items-center whitespace-nowrap w-max">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="text-sm sm:text-base font-semibold tracking-[0.18em] uppercase text-white/85 px-6">
              {item}
            </span>
            <Asterisk size={18} className="text-sky-400 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};
